module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-89.08a3265.woff2";